export class SetupAwsPrivateLinkResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SetupAwsPrivateLinkResponse.attributeTypeMap;
    }
    constructor() {
    }
}
